import React from 'react';
import { ProfileCompletionConst } from '@axiom/const';

import type { BannerPromptProps } from '../ProfileCompletionBanner/ProfileCompletionBanner';
import { ProfileCompletionBanner } from '../ProfileCompletionBanner/ProfileCompletionBanner';

export const AccomplishmentsBannerPrompt = ({
  onOpenEdit,
}: {
  onOpenEdit?: BannerPromptProps['onOpenEdit'];
}) => {
  return (
    <ProfileCompletionBanner
      items={[
        {
          title:
            ProfileCompletionConst.ProfileCompletionAccomplishmentsBanner
              .missingTitle,
          description:
            ProfileCompletionConst.ProfileCompletionAccomplishmentsBanner
              .missingContent,
          estimatedTime: '5 min',
        },
      ]}
      onOpenEdit={onOpenEdit}
      name="ACCOMPLISHMENTS_BANNER_PROMPT"
    />
  );
};
